const XLSX = require('xlsx');

export default class myUtils {
    static json2excel(json, sheetName = 'sheet', dataName = 'excel') {
        const workBook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(json);
        // console.log(worksheet);
        XLSX.utils.book_append_sheet(workBook, worksheet, sheetName);
        XLSX.writeFile(workBook, dataName + '.xlsx');
    };
    static html2excel(ele, sheetName = 'sheet', dataName = 'excel') {
        const workBook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.table_to_sheet(ele);
        // console.log(worksheet);
        XLSX.utils.book_append_sheet(workBook, worksheet, sheetName);
        XLSX.writeFile(workBook, dataName + '.xlsx');
    }
}
